import { Component, Prop, Vue } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel } from "../models/product";

@Component
export default class UniqueVariantFilter extends Vue {

    @Prop()
    protected variants!: Variant[];
    protected translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    get selectedVariant(): Variant {
        return productStore.variant;
    }

    set selectedVariant(value: Variant) {
        productStore.dispatchVariant(value);
    }

    private variantExist(variantId: string): boolean {
        for (const item of this.variants) {
            if (item.variantId === variantId) {
                return true;
            }
        }
        return false;
    }
}
